import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokolhapurtempo() {


const cardData = {
keyword: "Pune to Kolhapur Tempo Traveller Rent",
headingDescription: "Ruturaj Enterprises provides Pune to Kolhapur Tempo Traveller Rent services for families, friends, corporate teams, pilgrimage groups, tourists, and organized travel parties. Comfortable AC, luxury, 13 seater, 17 seater, and 20 seater Tempo Traveller options can be arranged for one-way journeys, round trips, weekend holidays, sightseeing, family tours, and visits to important attractions such as Mahalaxmi Temple and Panhala Fort. Group transportation can be planned around convenient Pune pickup points, preferred departure times, passenger capacity, luggage requirements, sightseeing stops, and return schedules.",
topPlaces: [
{
title: "Mahalaxmi Temple",
description: "Mahalaxmi Temple is one of Kolhapur's most important religious landmarks and attracts devotees throughout the year. A dedicated Tempo Traveller provides convenient transportation for families and pilgrimage groups traveling from Pune for Darshan and nearby sightseeing."
},
{
title: "Panhala Fort",
description: "Panhala Fort is a historic hill fort near Kolhapur known for its heritage, scenic surroundings, and connection with Maratha history. Groups traveling from Pune can include the fort in their Kolhapur itinerary while enjoying the convenience of common transportation."
},
{
title: "Rankala Lake",
description: "Rankala Lake is a popular recreational destination in Kolhapur, offering a pleasant setting for evening walks and family outings. A Tempo Traveller allows groups to comfortably include the lake in a broader Kolhapur sightseeing schedule."
},
{
title: "Jyotiba Temple",
description: "Jyotiba Temple is an important religious destination located on a hill near Kolhapur and is visited by devotees from Maharashtra and nearby regions. Pilgrimage groups can conveniently include the temple along with Mahalaxmi Temple during a planned trip from Pune."
},
{
title: "New Palace",
description: "New Palace is a significant heritage attraction in Kolhapur featuring historical architecture and cultural importance. Tourists and families can add the palace to their sightseeing itinerary while traveling between Kolhapur's major attractions in a dedicated traveller."
},
{
title: "Gaganbawda",
description: "Gaganbawda is known for its green landscapes, hills, valleys, and peaceful surroundings in the Kolhapur region. Nature-loving groups can extend their Pune to Kolhapur journey with a scenic excursion to this less crowded destination."
},
{
title: "Narsobawadi",
description: "Narsobawadi is a prominent spiritual destination situated near the confluence of the Krishna and Panchganga rivers. Families and devotees can include the location in a pilgrimage-focused Kolhapur itinerary when planning a multi-stop group tour."
},
{
title: "Dajipur Wildlife Sanctuary",
description: "Dajipur Wildlife Sanctuary offers a natural setting with forests, hills, and wildlife attractions in the Kolhapur region. A larger group can plan an extended sightseeing trip and use a dedicated Tempo Traveller to travel between selected destinations."
},
{
title: "Kopeshwar Temple",
description: "Kopeshwar Temple at Khidrapur is a remarkable historical temple known for its stone architecture and artistic carvings. It can be included as a heritage and pilgrimage stop for groups extending their Kolhapur travel itinerary beyond the city."
},
{
title: "Amboli Ghat",
description: "Amboli Ghat is a scenic hill destination surrounded by forests, waterfalls, and Western Ghats landscapes. Groups planning a longer weekend trip from Pune toward Kolhapur can consider Amboli as an additional nature-focused destination."
}
],
services: [
{
name: "Pune to Kolhapur Tempo Traveller on Rent",
description: "Pune to Kolhapur Tempo Traveller on Rent provides dedicated group transportation for families, friends, tourists, corporate teams, and pilgrimage groups. Vehicle capacity can be selected according to passenger count, luggage, comfort preferences, trip duration, and the planned Kolhapur itinerary."
},
{
name: "Pune to Kolhapur Tempo Traveller Hire",
description: "Pune to Kolhapur Tempo Traveller Hire is suitable for travelers who want everyone to journey together without arranging multiple cars. The service can support one-way travel, round trips, sightseeing programs, family holidays, religious visits, and weekend excursions."
},
{
name: "Pune Kolhapur Tempo Traveller Booking",
description: "Pune Kolhapur Tempo Traveller Booking allows groups to organize transportation in advance for their selected travel date. Passenger strength, pickup location, preferred vehicle, AC requirements, sightseeing plans, departure time, and return schedule can be considered during trip planning."
},
{
name: "Pune Kolhapur AC Tempo Traveller",
description: "Pune Kolhapur AC Tempo Traveller offers a comfortable travel option for families, tourists, corporate groups, and pilgrimage parties traveling between the two cities. Air-conditioned transportation is especially convenient for groups planning a full-day journey with multiple sightseeing stops."
},
{
name: "Pune Kolhapur Luxury Tempo Traveller",
description: "Pune Kolhapur Luxury Tempo Traveller is suitable for travelers who prefer a premium and comfortable group travel experience. It can be considered for family holidays, corporate trips, special occasions, weekend tours, and extended sightseeing programs."
},
{
name: "13 Seater Tempo Traveller Pune to Kolhapur",
description: "13 Seater Tempo Traveller Pune to Kolhapur is a practical choice for medium-sized families, friend groups, and small tour parties. The vehicle provides dedicated group transportation for the route while allowing passengers to travel together with space for essential luggage."
},
{
name: "17 Seater Tempo Traveller Pune to Kolhapur",
description: "17 Seater Tempo Traveller Pune to Kolhapur is suitable for larger families, corporate groups, pilgrimage parties, and organized tours. It provides a common travel solution for groups that need more seating capacity while planning a direct journey or sightseeing itinerary."
},
{
name: "20 Seater Tempo Traveller Pune to Kolhapur",
description: "20 Seater Tempo Traveller Pune to Kolhapur is designed for larger travel groups requiring additional seating capacity for an organized trip. It can be used for family functions, group holidays, pilgrimage tours, corporate travel, and extended Kolhapur sightseeing."
},
{
name: "Pune Kolhapur Family Trip Traveller",
description: "Pune Kolhapur Family Trip Traveller provides convenient transportation for families planning a spiritual, cultural, or recreational holiday. The itinerary can include Mahalaxmi Temple, Rankala Lake, Panhala Fort, and other attractions while keeping the complete family group together."
},
{
name: "Pune Kolhapur Group Travel Traveller",
description: "Pune Kolhapur Group Travel Traveller is suitable for friends, relatives, social organizations, tour groups, and community parties. A dedicated vehicle simplifies coordination and allows the group to follow a common schedule throughout the Pune to Kolhapur journey."
},
{
name: "Pune Kolhapur Outstation Tempo Traveller",
description: "Pune Kolhapur Outstation Tempo Traveller provides a suitable transportation option for groups traveling outside Pune city for a planned holiday or pilgrimage. The traveller can be arranged according to passenger capacity, journey duration, route requirements, sightseeing stops, and return plans."
},
{
name: "Pune Kolhapur Round Trip Traveller",
description: "Pune Kolhapur Round Trip Traveller covers the complete onward and return journey for groups planning a scheduled visit to Kolhapur. It is useful for one-day tours, pilgrimage trips, family outings, weekend travel, and sightseeing programs where return transportation is required."
},
{
name: "Pune Kolhapur One Way Traveller",
description: "Pune Kolhapur One Way Traveller is suitable for passengers who need dedicated transportation from Pune to Kolhapur without a planned return journey. It can be useful for family transfers, relocation-related travel, event attendance, pilgrimage visits, and onward travel arrangements."
},
{
name: "Affordable Tempo Traveller Pune Kolhapur",
description: "Affordable Tempo Traveller Pune Kolhapur provides a practical group travel solution for passengers looking to manage transportation expenses efficiently. Choosing a traveller that matches the group size can help avoid unnecessary multiple-car arrangements while maintaining convenient shared travel."
},
{
name: "Kolhapur Tour Traveller from Pune",
description: "Kolhapur Tour Traveller from Pune is suitable for tourists planning a dedicated trip covering the city's temples, forts, lakes, heritage attractions, and nearby destinations. Groups can customize the itinerary according to available time and preferred sightseeing locations."
},
{
name: "Pune Kolhapur Sightseeing Traveller",
description: "Pune Kolhapur Sightseeing Traveller allows groups to explore multiple attractions during the same trip rather than arranging separate transportation between locations. The itinerary can include religious sites, heritage landmarks, scenic destinations, and recreational places around Kolhapur."
},
{
name: "Tempo Traveller for Mahalaxmi Temple Kolhapur",
description: "Tempo Traveller for Mahalaxmi Temple Kolhapur is ideal for devotees and families traveling from Pune for Darshan. A dedicated traveller helps the group maintain a common schedule and can also accommodate additional religious or sightseeing stops around Kolhapur."
},
{
name: "Pune Kolhapur Pilgrimage Traveller",
description: "Pune Kolhapur Pilgrimage Traveller provides organized transportation for devotees visiting Mahalaxmi Temple, Jyotiba Temple, Narsobawadi, and other spiritual destinations. The journey can be planned around temple visits, meal breaks, rest periods, and the group's preferred return timing."
},
{
name: "Pune Kolhapur Weekend Trip Traveller",
description: "Pune Kolhapur Weekend Trip Traveller is suitable for friends, families, couples traveling in groups, and corporate teams planning a short getaway. The itinerary can combine Kolhapur's historical, religious, culinary, and scenic attractions within a convenient weekend schedule."
},
{
name: "Pune Kolhapur AC Traveller Rental",
description: "Pune Kolhapur AC Traveller Rental provides a comfortable option for groups traveling over the longer Pune-Kolhapur route. Air-conditioned group transportation is suitable for family tours, pilgrimage trips, corporate journeys, tourist excursions, and weekend travel."
},
{
name: "Luxury Traveller Hire Pune Kolhapur",
description: "Luxury Traveller Hire Pune Kolhapur is intended for groups seeking enhanced comfort and a premium travel environment. It can be arranged for family holidays, corporate travel, special occasions, religious tours, and sightseeing programs where a more comfortable vehicle is preferred."
},
{
name: "Pune Kolhapur Group Tour Traveller",
description: "Pune Kolhapur Group Tour Traveller provides dedicated transportation for organized group tours covering Kolhapur's temples, forts, lakes, heritage attractions, and surrounding destinations. The traveller keeps passengers together and makes it easier to coordinate the complete tour itinerary."
}
],
tableData: [
["Pune to Kolhapur Tempo Traveller on Rent", "Pune to Kolhapur Tempo Traveller Hire"],
["Pune Kolhapur Tempo Traveller Booking", "Pune Kolhapur AC Tempo Traveller"],
["Pune Kolhapur Luxury Tempo Traveller", "13 Seater Tempo Traveller Pune to Kolhapur"],
["17 Seater Tempo Traveller Pune to Kolhapur", "20 Seater Tempo Traveller Pune to Kolhapur"],
["Pune Kolhapur Family Trip Traveller", "Pune Kolhapur Group Travel Traveller"],
["Pune Kolhapur Outstation Tempo Traveller", "Pune Kolhapur Round Trip Traveller"],
["Pune Kolhapur One Way Traveller", "Affordable Tempo Traveller Pune Kolhapur"],
["Kolhapur Tour Traveller from Pune", "Pune Kolhapur Sightseeing Traveller"],
["Tempo Traveller for Mahalaxmi Temple Kolhapur", "Pune Kolhapur Pilgrimage Traveller"],
["Pune Kolhapur Weekend Trip Traveller", "Pune Kolhapur AC Traveller Rental"],
["Luxury Traveller Hire Pune Kolhapur", "Pune Kolhapur Group Tour Traveller"]
],
whychoose: [
{
WhyChooseheading: "Comfortable Pune to Kolhapur Travel",
WhyChoosedescription: "A dedicated Tempo Traveller gives families and groups a convenient alternative to traveling in multiple cars. Everyone can follow the same route and schedule while enjoying a shared journey from Pune to Kolhapur."
},
{
WhyChooseheading: "Multiple Seating Capacities",
WhyChoosedescription: "Different groups require different amounts of seating, so 13, 17, and 20 seater options can be considered according to passenger strength. Selecting an appropriately sized traveller helps create a practical arrangement for both passengers and luggage."
},
{
WhyChooseheading: "Ideal for Pilgrimage Trips",
WhyChoosedescription: "Kolhapur is an important destination for devotees visiting Mahalaxmi Temple and other religious sites. Group transportation makes it easier for families and pilgrimage parties to coordinate Darshan, temple visits, meal breaks, and return travel."
},
{
WhyChooseheading: "Suitable for Family Holidays",
WhyChoosedescription: "Families can use a dedicated traveller for a relaxed trip covering temples, forts, lakes, heritage attractions, and nearby scenic destinations. Traveling together also makes it simpler to manage children, elderly family members, luggage, and sightseeing stops."
},
{
WhyChooseheading: "AC and Luxury Options",
WhyChoosedescription: "Travelers who prioritize comfort can choose AC or luxury-oriented Tempo Traveller options for the Pune-Kolhapur journey. These vehicles are useful for longer trips, weekend holidays, corporate travel, premium family outings, and organized tours."
},
{
WhyChooseheading: "Flexible One-Way or Round Trips",
WhyChoosedescription: "Travel requirements vary from passenger to passenger, so both one-way and round-trip arrangements can be planned. This flexibility is useful for travelers visiting Kolhapur for events, family functions, pilgrimages, holidays, or onward journeys."
},
{
WhyChooseheading: "Convenient Sightseeing Planning",
WhyChoosedescription: "A Kolhapur tour can include several attractions beyond the main destination, including Panhala Fort, Rankala Lake, Jyotiba Temple, and heritage sites. A dedicated traveller allows the group to organize these stops without depending on separate local transportation."
},
{
WhyChooseheading: "Practical Group Transportation",
WhyChoosedescription: "Using one traveller for a group can simplify coordination, departure management, and communication throughout the trip. It is suitable for families, friends, corporate teams, tourists, pilgrimage groups, and other organized parties traveling from Pune to Kolhapur."
}
]
};












const faqData = [
{
question: "Can I rent a Tempo Traveller from Pune to Kolhapur?",
answer: "A Tempo Traveller is a convenient option for families, friends, corporate teams, and other groups traveling from Pune to Kolhapur. Ruturaj Enterprises can help arrange a suitable vehicle according to the number of passengers, luggage, preferred departure time, and overall travel plan."
},
{
question: "Is a Tempo Traveller suitable for a Pune to Kolhapur trip?",
answer: "Group travelers can benefit from a Tempo Traveller because everyone can travel together in one dedicated vehicle. It is especially useful for a Kolhapur trip involving family members or friends who want coordinated pickup, comfortable road travel, planned stops, and a convenient return journey."
},
{
question: "Can I book a Tempo Traveller for a round trip from Pune to Kolhapur?",
answer: "Round-trip Tempo Traveller rental can be arranged for passengers who plan to travel from Pune to Kolhapur and return after completing their visit. Keeping the same vehicle for both directions makes it easier to manage sightseeing, meal breaks, local travel, and the return schedule."
},
{
question: "What can we visit in Kolhapur during the trip?",
answer: "A Pune to Kolhapur itinerary can include popular attractions such as Mahalaxmi Temple, Panhala Fort, Rankala Lake, New Palace, and other local places of interest. The sightseeing plan can be adjusted according to the group's available time and preferred destinations."
},
{
question: "Can families hire a Tempo Traveller from Pune to Kolhapur?",
answer: "Families traveling with children, parents, or relatives can choose a Tempo Traveller for a more coordinated road journey. Having a dedicated vehicle allows everyone to stay together while carrying luggage and planning convenient breaks during the Pune to Kolhapur trip."
},
{
question: "Is a Tempo Traveller good for a group pilgrimage to Kolhapur?",
answer: "Kolhapur is a popular destination for devotees visiting the Mahalaxmi Temple, and a private Tempo Traveller can be useful for group pilgrimage travel. The vehicle provides a common mode of transportation for the entire group and can accommodate the itinerary around temple visits and other planned stops."
},
{
question: "What seating capacity can I choose for a Pune to Kolhapur Tempo Traveller?",
answer: "The appropriate seating capacity depends on the number of travelers and the amount of luggage being carried. Ruturaj Enterprises can help identify a suitable Tempo Traveller based on group size, desired comfort, luggage space, journey duration, and whether local sightseeing is included."
},
{
question: "Can corporate groups rent a Tempo Traveller for Kolhapur?",
answer: "Corporate teams can use a Tempo Traveller for employee outings, business travel, team trips, conferences, and group excursions to Kolhapur. A dedicated vehicle keeps the team together and makes it easier to maintain a shared travel schedule throughout the journey."
},
{
question: "Can we include sightseeing while renting a Tempo Traveller to Kolhapur?",
answer: "Local sightseeing can be incorporated into the travel plan when the schedule permits. Groups can discuss places they wish to visit in and around Kolhapur while arranging the rental, allowing the journey to combine intercity transportation with planned local travel."
},
{
question: "Why choose Ruturaj Enterprises for Pune to Kolhapur Tempo Traveller rental?",
answer: "Ruturaj Enterprises offers group transportation for travelers planning Pune to Kolhapur journeys, including family trips, pilgrimages, corporate outings, and sightseeing tours. Vehicle selection can be matched with passenger count, luggage, travel duration, and itinerary requirements for a well-organized journey."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Rahul Sawant",
feedback:
"We rented a Tempo Traveller from Ruturaj Enterprises for our family trip from Pune to Kolhapur. Everyone was able to travel together, and we had enough flexibility to plan our temple visit and sightseeing. The complete journey was convenient and well suited to our group.",
rating: 5
},
{
id: 2,
name: "Miss. Sneha Joshi",
feedback:
"Our group chose a Tempo Traveller for a Kolhapur trip from Pune and had a very comfortable travel experience. Ruturaj Enterprises helped us with a suitable vehicle for our group, making the road journey, local sightseeing, and return trip much easier to coordinate.",
rating: 5
}
];







































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Kolhapur Tempo Traveller Rent",
  "image": "https://ruturajenterprises.com/assets/images/pune-to-kolhapur-tempo-traveller-rent.webp",
  "description":
    "Pune to Kolhapur Tempo Traveller Rent for family trips, group tours, religious journeys, corporate travel, weddings, and sightseeing. Ruturaj Enterprises offers comfortable AC and luxury Tempo Traveller options from Pune to Kolhapur with suitable seating capacities, experienced drivers, convenient pickup arrangements, and flexible rental plans. The service is suitable for visits to Kolhapur, Mahalaxmi Temple, Panhala Fort, Jyotiba, and nearby destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/pune-to-kolhapur-tempo-traveller-rent"
  }
};






    return (
        <div>

<Helmet>
  <title>
    Pune to Kolhapur Tempo Traveller Rent | Pune Kolhapur Tempo Traveller | +91 9763381382
  </title>

  <meta
    name="description"
    content="Pune to Kolhapur Tempo Traveller Rent for family trips, group tours, temple visits, corporate travel, weddings and sightseeing. Hire comfortable AC and luxury Tempo Travellers from Pune with flexible rental options."
  />

  <meta
    name="keywords"
    content="Pune to Kolhapur Tempo Traveller on Rent, Pune to Kolhapur Tempo Traveller Hire, Pune Kolhapur Tempo Traveller Booking, Pune Kolhapur AC Tempo Traveller, Pune to Kolhapur Tempo Traveller Rental, Pune to Kolhapur Tempo Traveller Booking, AC Tempo Traveller Pune to Kolhapur, Luxury Tempo Traveller Pune to Kolhapur, 12 Seater Tempo Traveller Pune to Kolhapur, 13 Seater Tempo Traveller Pune to Kolhapur, 14 Seater Tempo Traveller Pune to Kolhapur, 17 Seater Tempo Traveller Pune to Kolhapur, 20 Seater Tempo Traveller Pune to Kolhapur, 26 Seater Tempo Traveller Pune to Kolhapur, Pune Kolhapur Tempo Traveller Rental, Pune Kolhapur Tempo Traveller Hire, Pune Kolhapur Tempo Traveller Service, Pune Kolhapur Tourist Tempo Traveller, Pune Kolhapur Group Travel Tempo Traveller, Pune Kolhapur Family Trip Tempo Traveller, Pune Kolhapur One Day Trip Tempo Traveller, Pune Kolhapur Weekend Trip Tempo Traveller, Pune Kolhapur AC Traveller Rental, Pune Kolhapur Luxury Traveller Rental, Tempo Traveller for Kolhapur Tour from Pune, Tempo Traveller for Kolhapur Family Trip Pune, Tempo Traveller for Kolhapur Group Tour Pune, Tempo Traveller for Kolhapur Temple Tour Pune, Tempo Traveller for Kolhapur Religious Tour Pune, Tempo Traveller for Kolhapur Corporate Trip Pune, Tempo Traveller for Kolhapur Wedding Pune, Tempo Traveller for Kolhapur Picnic Pune, Tempo Traveller for Kolhapur Sightseeing Pune, Pune to Kolhapur Tourist Tempo Traveller, Pune to Kolhapur Outstation Tempo Traveller, Pune to Kolhapur One Way Tempo Traveller, Pune to Kolhapur Round Trip Tempo Traveller, Pune to Kolhapur AC Traveller on Rent, Pune to Kolhapur Luxury Traveller on Rent, Pune Kolhapur Mahalaxmi Temple Tempo Traveller, Pune to Kolhapur Mahalaxmi Temple Tempo Traveller, Pune Kolhapur Panhala Fort Tempo Traveller, Pune to Panhala Fort Tempo Traveller, Pune Kolhapur Jyotiba Temple Tempo Traveller, Pune to Jyotiba Temple Tempo Traveller, Pune Kolhapur Sightseeing Tempo Traveller, Pune Kolhapur Tour Package by Tempo Traveller, Pune Kolhapur Tour Bus Traveller Rental, Affordable Pune to Kolhapur Tempo Traveller, Tempo Traveller Rental Near Me Pune, Ruturaj Enterprises Pune Kolhapur Tempo Traveller Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokolhapurtempo ;